import axios from 'axios'
// 创建 axios 实例
const requests = axios.create({
  baseURL: '',
  timeout: 60000, // 请求超时时间
})

// 错误处理函数
const err = (error) => {
  if (error.response) {
    const data = error.response.data
    // const token = Vue.ls.get(ACCESS_TOKEN)
    // if (error.response.status === 403) {
    //   window.vm.$message({
    //     type: 'error',
    //     message: data.message || data.msg,
    //     showClose: true,
    //     duration: 5000
    //   })
    // }
    if (error.response.status === 401) {
      window.vm.$message({
        type: 'error',
        message: '你没有权限。',
        showClose: true,
        duration: 5000
      })
    }
  }
  return Promise.reject(error)
}

// request interceptor(请求拦截器)
requests.interceptors.request.use(config => {
  if(config.url =="http://172.17.37.60:8000/smartfactory-alarm/alarm/summary/count_board"){
    config.headers['companyId'] = '694587217707794432';
  }
  if(config.url.split('/')[3]=='reportServer'){
    config.headers['credentials'] = "{'userName':'dpksh','pwd':'123456'}"
    config.headers['Content-Type'] = "application/json"
  }
  //if (sessionStorage.getItem('token')) {
    // const token = sessionStorage.getItem('token')
    // config.headers['token'] = `bearer:${token}` // 让每个请求携带自定义 token 请根据实际情况自行修改
  //}
  return config
}, err)

// response interceptor（接收拦截器）
requests.interceptors.response.use((response) => {
  const res = response.data
  // if (res.code !== '0' || res.code !== '200' || res.code !== undefined) {
  //   window.vm.$message.error(res)
  //   return Promise.reject('error')
  // } else {
  //   return res
  // }
  if (res.code !== '200') {
    // window.vm.$message.error(res)
    return Promise.reject(res)
  } else {
    return res
  }

}, err)

export default requests



// WEBPACK FOOTER //
// ./src/libs/axios2.js